/**
 * GS-900 — where the result site's calls go, per environment (Vue CLI `.env.<mode>` files; see `.env.example`).
 *
 * With nothing set, every value is what the site always had: the legacy hosts and no sign-in. An EMPTY base
 * (`VUE_APP_SES_BASE=`) means the site's own origin, for a host that serves the site and proxies `/api` beside it.
 */
const env = process.env;

const LEGACY_SES = 'https://sky-seservice.gratitude-software.in';
const LEGACY_DATA = 'https://sky-data-source.gratitude-software.in';

function base(value: string | undefined, fallback: string): string {
  return (value === undefined ? fallback : value).trim().replace(/\/+$/, '');
}

export const AppConfig = {
  /** SES: the director's result and event calls, and the sign-in. */
  sesBase: base(env.VUE_APP_SES_BASE, LEGACY_SES),
  /** The data house: event management's match list. */
  dataBase: base(env.VUE_APP_DATA_BASE, LEGACY_DATA),
  /** SES's sign-in, answered with a token: `/api/auth/signin` on SES itself. */
  signinPath: (env.VUE_APP_SIGNIN_PATH || '/api/auth/signin').trim(),
  /**
   * Whether an operator must sign in. SES has refused an anonymous `/api/director/**` call since GS-481, so every
   * environment that talks to our SES sets this to `true`; the legacy SES never asked.
   */
  requireSignin: (env.VUE_APP_REQUIRE_SIGNIN || '').trim() === 'true',
};

/** A path on SES, e.g. `sesUrl('/api/director/pendingResults')`. */
export function sesUrl(path: string): string {
  return AppConfig.sesBase + path;
}

/** A path on the data house. */
export function dataUrl(path: string): string {
  return AppConfig.dataBase + path;
}
